/**
 * @file useElementMutation
 * @author yuzong(yuzong@tencent.com)
 */
import { useCallback, useEffect, useRef } from 'react';
import { isClient } from '@tencent/glue-util-boundary';
import { addMutationHandler, removeMutationHandler } from '@tencent/glue-dom-mutation';
import { useRefCallback, useRefFunction } from '@tencent/glue-react-use';
export function useElementMutation(isEnable, callback) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var _options$disabledCapt = options.disabledCaptureElementSizeChange,
      disabledCaptureElementSizeChange = _options$disabledCapt === void 0 ? false : _options$disabledCapt,
      _options$disabledCapt2 = options.disabledCaptureWindowSize,
      disabledCaptureWindowSize = _options$disabledCapt2 === void 0 ? false : _options$disabledCapt2,
      _options$disabledCapt3 = options.disabledCaptureAnimation,
      disabledCaptureAnimation = _options$disabledCapt3 === void 0 ? false : _options$disabledCapt3,
      _options$disabledCapt4 = options.disabledCaptureContainerScroll,
      disabledCaptureContainerScroll = _options$disabledCapt4 === void 0 ? false : _options$disabledCapt4,
      _options$disabledCapt5 = options.disabledCaptureElementUpdate,
      disabledCaptureElementUpdate = _options$disabledCapt5 === void 0 ? false : _options$disabledCapt5,
      _options$disabledCapt6 = options.disabledCaptureTransition,
      disabledCaptureTransition = _options$disabledCapt6 === void 0 ? false : _options$disabledCapt6;
  var element = useRef(null);
  var isEnableRef = useRefFunction(isEnable);
  var cb = useRefCallback(callback);
  var update = useCallback(function () {
    var init = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
    var elem = element.current;

    if (!isEnableRef() || elem == null) {
      return;
    }

    cb(elem, init);
  }, []); // 这样可以在组件刷新的时候，更新一下位置

  useEffect(function () {
    if (disabledCaptureElementUpdate) {
      return;
    }

    update();
  }); // 组件初始化的时候报告一下位置

  useEffect(function () {
    update(true);

    if (isClient()) {
      // 任何属性的变化或者元素
      addMutationHandler(update, {
        mutation: !disabledCaptureElementSizeChange,
        transition: !disabledCaptureTransition,
        animation: !disabledCaptureAnimation,
        scroll: !disabledCaptureContainerScroll,
        resize: !disabledCaptureWindowSize
      });
      return function () {
        removeMutationHandler(update);
      };
    }
  }, [disabledCaptureElementSizeChange, disabledCaptureTransition, disabledCaptureAnimation, disabledCaptureContainerScroll, disabledCaptureWindowSize]);
  var ref = useCallback(function (node) {
    return element.current = node;
  }, []);
  return [ref, update];
}